module.exports = __webpack_public_path__ + "img/logo.c7f2d13a.png";